// ==============================|| BsForm ||============================== //
export default function BsForm(props: React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>) {
  return <form {...props}>{props.children}</form>;
}
